/**
 * Cookie类库
 *
 * @Author: Shann
 * @LastEditors: Shann
 * @Date: 2021-03-24 10:39:36
 * @LastEditTime: 2021-04-09 09:04:31
 * @FilePath: \buyer-one\dop-webapp\src\utils\cookie.js
 */

import Cookie from "js-cookie";

export default Cookie;
